import { useEffect, useState } from "react";
import Logo from "./Logo.jsx";

export const NAV = [
  { id: "anlaesse", label: "Anlässe" },
  { id: "mitglieder", label: "Mitglieder" },
];

export default function Header({ settings, active, onAdmin }) {
  const [open, setOpen] = useState(false);

  // Schublade schliessen, sobald wieder Platz für die volle Navigation ist.
  useEffect(() => {
    if (!open) return;
    const mq = window.matchMedia("(min-width: 901px)");
    const close = () => setOpen(false);
    mq.addEventListener("change", close);
    return () => mq.removeEventListener("change", close);
  }, [open]);

  const links = (
    <>
      {NAV.map((n) => (
        <a
          key={n.id}
          className="nav-link"
          href={`#${n.id}`}
          data-active={active === n.id}
          aria-current={active === n.id ? "true" : undefined}
          onClick={() => setOpen(false)}
        >
          {n.label}
        </a>
      ))}
      {settings.linkedin ? (
        <a
          className="nav-link"
          href={settings.linkedin}
          target="_blank"
          rel="noreferrer"
          onClick={() => setOpen(false)}
        >
          LinkedIn-Gruppe
        </a>
      ) : null}
    </>
  );

  return (
    <header className="head">
      <div className="head-in">
        <a className="brand" href="#top" aria-label={settings.groupName} onClick={() => setOpen(false)}>
          <Logo className="brand-mark" />
          <span className="brand-text">
            Jung Unternehmer
            <small>{settings.region}</small>
          </span>
        </a>

        <nav className="nav" aria-label="Hauptnavigation">
          {links}
          <a className="btn" href="#mitmachen">
            Firma anmelden
          </a>
        </nav>

        <button
          className="burger"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-controls="drawer"
        >
          <b aria-hidden="true">
            <i />
            <i />
            <i />
          </b>
          {open ? "Schliessen" : "Menu"}
        </button>
      </div>

      {open ? (
        <div className="drawer" id="drawer">
          <div className="wrap">
            {links}
            <a className="btn" href="#mitmachen" onClick={() => setOpen(false)}>
              Firma anmelden
            </a>
            <button
              onClick={() => {
                setOpen(false);
                onAdmin();
              }}
            >
              Verwaltung
            </button>
          </div>
        </div>
      ) : null}
    </header>
  );
}
